import Marquee from "react-fast-marquee";

const ITEMS = [
  "100% Fiat Currency Payouts",
  "Data Monetization",
  "Map the World",
  "Direct Bank Transfers",
];

export const TrustMarquee = () => {
  return (
    <section
      data-testid="trust-bar"
      className="relative border-y border-white/10 bg-[#050d1a] py-6"
    >
      <Marquee speed={38} gradient={false} pauseOnHover>
        {ITEMS.map((item, i) => (
          <div key={i} className="flex items-center">
            <span className="font-display font-semibold uppercase tracking-tight text-lg md:text-2xl text-slate-100/90 px-8">
              {item}
            </span>
            <span className="text-[#4CAF50] text-2xl px-2">&#9679;</span>
          </div>
        ))}
      </Marquee>
    </section>
  );
};
